import clsx from 'clsx';

import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';

import { Form } from '@unform/web';

import { Box, Button as MUIButton, Container, Divider, Grid, Hidden, IconButton, InputAdornment, Link, Typography } from '@material-ui/core';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';
import SendIcon from '@material-ui/icons/Send';

import { TabContext, TabPanel, ToggleButton, ToggleButtonGroup } from '@material-ui/lab';

import imgBanner from '../../assets/img/indique-ganhe/banner.png';
import imgIcon from '../../assets/img/indique-ganhe/icon.png';
import imgCartaoVirtualMastercard from '../../assets/img/indique-ganhe/parceiros/logo-cartao-virtual-mastercard.png'
import imgIFood from '../../assets/img/indique-ganhe/parceiros/logo-ifood.png';
import Button from '../../components/Form/Button';
import Check from '../../components/Form/Check';
import Input from '../../components/Form/Input';
import Radio from '../../components/Form/Radio';
import Html from '../../components/Html';
import NotEmpty from '../../components/NotEmpty';
import NotLoading from '../../components/NotLoading';
import Subtitle from '../../components/Subtitle';
import Title from '../../components/Title';
import AfiliadoIndicacaoOrigem from '../../constants/AfiliadoIndicacaoOrigem';
import Situacao from '../../constants/Situacao';
import DateHelper from '../../helpers/DateHelper';
import TextHelper from '../../helpers/TextHelper';
import UtilHelper from '../../helpers/UtilHelper';
import ValidateHelper from '../../helpers/ValidateHelper';
import useAuth from '../../hooks/useAuth';
import useModal from '../../hooks/useModal';
import useOffline from '../../hooks/useOffline';
import useSnackbar from '../../hooks/useSnackbar';
import IndiqueGanheService from '../../services/IndiqueGanheService';
import useStyles from './useStyles';

const imgParceiros = {
  'logo-cartao-virtual-mastercard.png': imgCartaoVirtualMastercard,
  'logo-ifood.png': imgIFood,
};

const createTab = (value, label) => ({ label, value });

const tabs = [
  // Criar abas
  createTab('indicar-pessoas', 'indicar pessoas'),
  createTab('como-funciona', 'como funciona?'),
  createTab('meus-bonus', 'meus bônus $'),
];

const linhasDeNegocio = [
  { id_linha_de_negocio: 2, st_linha_de_negocio: 'Graduação' },
  { id_linha_de_negocio: 3, st_linha_de_negocio: 'Pós-Graduação' },
];

const IndicacaoList = ({ setTabValue, refreshing, indicacoes, nu_recebido, nu_resgatado, nu_expirado, nu_disponivel, bl_inadimplente }) => {
  const [situacao, setSituacao] = useState(Situacao.AFILIADO_INDICACAO.PENDENTE);

  const filtered = useMemo(() => indicacoes?.filter(({ id_situacao }) => +id_situacao === situacao), [indicacoes, situacao]);
  const modal = useModal();
  const handleSituacao = useCallback((e, newSituacao) => {
    if (newSituacao) {
      setSituacao(newSituacao);
    }
  }, []);

  const handleInadimplente = () => {
    if (bl_inadimplente) {
      modal.alert({
        title: 'Bônus bloqueado!',
        content: '<div class="font-default text-left" style="text-align: center; font-size: 16px">Identificamos uma pendência financeira em seu cadastro. Orientamos que regularize a situação e retorne para resgatar o seu bônus normalmente.\n' +
          '        <br><br>Em caso de dúvidas entre em contato conosco registrando uma ocorrência por meio do Serviço de Atenção.</div>',
      });
      return;
    }
    return setTabValue('resgatar')
  }

  return (
    <Box width={{ lg: 830 }}>
      <Box my={2}>
        <Typography>
          Você enviou {indicacoes?.length} indicaç{indicacoes?.length > 1 ? 'ões' : 'ão'}. Quando a pessoa se matricula, você ganha um bônus!
        </Typography>
      </Box>
      <ToggleButtonGroup exclusive size="small" value={situacao} onChange={handleSituacao}>
        <ToggleButton value={Situacao.AFILIADO_INDICACAO.PENDENTE}>indicações pendentes</ToggleButton>
        <ToggleButton value={Situacao.AFILIADO_INDICACAO.CONFIRMADO}>bônus recebidos</ToggleButton>
      </ToggleButtonGroup>
      {situacao === Situacao.AFILIADO_INDICACAO.CONFIRMADO && (
        <Box bgcolor="action.selected" borderRadius={5} my={1} p={1} fontSize={12}>
          <Grid container justifyContent="space-between" alignItems="center" spacing={1}>
            <Grid item>Total recebido: {TextHelper.toMoney(nu_recebido)}</Grid>
            <Grid item>Total expirado: {TextHelper.toMoney(nu_expirado)}</Grid>
            <Grid item>Total resgatado: {TextHelper.toMoney(nu_resgatado)}</Grid>
            <Grid item>
              <b>Total disponível: {TextHelper.toMoney(nu_disponivel)}</b>
            </Grid>
            <Grid item>
              <Button size="small" loading={refreshing} disabled={refreshing || nu_disponivel <= 0} onClick={() => handleInadimplente()}>
                resgatar $
              </Button>
            </Grid>
          </Grid>
        </Box>
      )}
      <Box>
        {filtered?.map((indicacao) => (
          <IndicacaoItem key={indicacao.id_afiliadoindicacao} indicacao={indicacao} />
        ))}
      </Box>
    </Box>
  );
};

const IndicacaoItem = ({ indicacao }) => {
  const classes = useStyles();

  const isPendente = +indicacao.id_situacao === Situacao.AFILIADO_INDICACAO.PENDENTE;
  const isExpirado = indicacao.bl_expirado;

  const getStatusCupom = (cupom, indicacao) => {
    const isDisponivel = +cupom.id_situacao === Situacao.AFILIADO_INDICACAO_CUPOM.DISPONIVEL;
    const isExpirado = isDisponivel && indicacao.bl_expirado;

    if (isExpirado) {
      return `Expirado em ${DateHelper.toFormatString(indicacao.dt_vencimento)}`;
    }

    if (isDisponivel) {
      return (
        <Typography variant="caption">
          <b>Disponível para resgate</b>
        </Typography>
      );
    }

    return `Resgatado em ${DateHelper.toFormatString(cupom.dt_resgate)}`;
  };

  return (
    <Box bgcolor="action.hover" borderRadius={5} my={1} p={2}>
      <Grid container justifyContent="space-between" alignItems="center" spacing={2}>
        <Grid item xs={12} md={isPendente ? 6 : 3}>
          <Typography>
            <b>{indicacao.st_nomeindicado}</b>
          </Typography>
          <Typography variant="caption">
            {indicacao.st_emailindicado}
            <br />
            {TextHelper.mask(`${indicacao.st_dddindicado}${indicacao.st_telefoneindicado}`, 'phone')}
          </Typography>
        </Grid>
        {isPendente && (
          <Grid item xs={12} md={6}>
            <Typography>Indicação em {DateHelper.toFormatString(indicacao.dt_cadastro)}</Typography>

            <Typography variant="caption" color={isExpirado ? 'error' : 'inherit'}>
              {isExpirado ? 'Expirada em ' : 'Válida até '}
              {DateHelper.toFormatString(indicacao.dt_vencimento)}
              {!isExpirado && <div>Aguardando matrícula do indicado.</div>}
            </Typography>
          </Grid>
        )}
        {!isPendente && (
          <>
            <Grid item xs={12} md={4}>
              <Box my={2} bgcolor="#fff" border={2} borderColor="secondary.light">
                <Grid container justifyContent="space-between" alignItems="center" wrap="nowrap">
                  <Grid item xs>
                    <Box p={1} align="center" whiteSpace="nowrap">
                      <Typography variant="body2" color="secondary">
                        BÔNUS DE <b>{TextHelper.toMoney(indicacao.nu_somacupons)}</b>
                      </Typography>
                      <Typography variant="caption">Válido até {DateHelper.toFormatString(indicacao.dt_vencimento)}</Typography>
                    </Box>
                  </Grid>
                  <Divider className={classes.divider} orientation="vertical" flexItem />
                  <Grid item>
                    <Box px={2} py={1} maxWidth={64}>
                      <img className="responsive" src={imgIcon} alt="Programa Indique e Ganhe" />
                    </Box>
                  </Grid>
                </Grid>
              </Box>
            </Grid>
            <Grid item xs={12} md={4}>
              <Grid item>
                {indicacao?.cupons?.map((cupom) => (
                  <Box key={cupom.id_afiliadoindicacaocupom}>
                    <Typography variant="caption">
                      <Box component="b" display="inline-block" width={70}>
                        {TextHelper.toMoney(cupom.nu_valor)}
                      </Box>
                      {getStatusCupom(cupom, indicacao)}
                    </Typography>
                  </Box>
                ))}
              </Grid>
            </Grid>
          </>
        )}
      </Grid>
    </Box>
  );
};

const resgatarDefaults = {
  nu_valor: 0,
  id_afiliadoindicacaoparceiro: null,
  id_situacao: Situacao.AFILIADO_INDICACAO_CUPOM.RESGATADO_VALE,
};

export default function IndiqueGanhe() {
  const formIndicarRef = useRef(null);
  const formResgatarRef = useRef(null);

  const classes = useStyles();
  const history = useHistory();
  const params = useParams();
  const modal = useModal();
  const snackbar = useSnackbar();
  const { user } = useAuth();

  const { tab = tabs[0].value } = params;

  const [tabValue, setTabValue] = useState(tab);
  const [resgatar, setResgatar] = useState(resgatarDefaults);
  const [savingIndicar, setSavingIndicar] = useState(false);
  const [savingResgatar, setSavingResgatar] = useState(false);

  useEffect(() => {
    if (resgatar && formResgatarRef.current) {
      formResgatarRef.current.setData(resgatar);
    }
  }, [resgatar]);

  const { id_usuario, id_entidade, id_matricula } = user;

  const getParceiros = useCallback(() => IndiqueGanheService.getParceiros(id_matricula), [id_matricula]);
  const getDados = useCallback(() => IndiqueGanheService.getIndicacoes(id_usuario, id_entidade), [id_usuario, id_entidade]);
  const getRegulamento = useCallback(() => IndiqueGanheService.getRegulamento(id_matricula), [id_matricula]);
  const getFuncionamento = useCallback(() => IndiqueGanheService.getComoFunciona(id_matricula), [id_matricula]);
  const getDadosPessoais = useCallback(() => IndiqueGanheService.getDadosPessoais(id_usuario, id_entidade), [id_usuario, id_entidade]);
  const { data: dadosPessoais } = useOffline('IndiqueGanhe.DadosPessoais', getDadosPessoais);
  const getBlInadimplente = useCallback(() => IndiqueGanheService.getBlInadimplente(id_entidade, dadosPessoais?.st_cpf), [id_entidade, dadosPessoais?.st_cpf]);

  const { data: dados, refresh: refreshDados, refreshing } = useOffline('IndiqueGanhe.Dados', getDados);
  const { data: parceiros } = useOffline('IndiqueGanhe.Parceiros', getParceiros);
  const { data: regulamento } = useOffline('IndiqueGanhe.Regulamento', getRegulamento);
  const { data: funcionamento } = useOffline('IndiqueGanhe.Funcionamento', getFuncionamento);
  const { data: statusInadimplente } = useOffline('IndiqueGanhe.BlInadimplente', getBlInadimplente);

  const prazoValeDisponivel = 10;

  const validateIndicar = (data) => {
    const errors = {};

    const { nome, telefone, email, termos_aceitos, linha_de_negocio } = data;

    if (`${nome}`.trim().split(' ').length < 2) {
      errors.nome = 'Informe o nome e o sobrenome da pessoa';
    }

    if (!ValidateHelper.phone(telefone)) {
      errors.telefone = 'Informe o telefone corretamente';
    }

    if (!ValidateHelper.email(email)) {
      errors.email = 'Informe o e-mail corretamente';
    }

    if (!linha_de_negocio) {
      errors.linha_de_negocio = 'Informe o interesse da pessoa';
    }

    if (!termos_aceitos) {
      errors.termos_aceitos = 'É necessário aceitar os termos do programa';
    }

    return errors;
  };

  const validateResgatar = (data) => {
    const errors = {};

    const nuMin = 100;
    const nuMax = dados?.nu_disponivel || 0;

    // O valor deve ser maior que o mínimo
    if (data.nu_valor < nuMin) {
      errors.nu_valor = `O valor do resgate não pode ser menor que R$ ${nuMin},00.`;
    }

    // O valor não pode ser maior que o disponível
    if (data.nu_valor > nuMax) {
      errors.nu_valor = `O valor do resgate não pode ser maior que R$ ${nuMax},00.`;
    }

    // O valor deve ser múltiplo de 100
    if (data.nu_valor % 100 !== 0) {
      errors.nu_valor = `O valor do resgate deve ser múltiplo de ${nuMin}.`;
    }

    // Para vale presente, é necessário informar o parceiro
    if (!data.id_afiliadoindicacaoparceiro) {
      errors.id_afiliadoindicacaoparceiro = 'É necessário selecionar o parceiro.';
    }

    return errors;
  };

  const handleRegulamento = (e) => {
    e.preventDefault();
    e.stopPropagation();

    modal.alert({
      title: 'Regulamento',
      content: <Regulamento idMatricula={id_matricula} regulamento={regulamento} />,
    });
  };

  const handleChangeTab = (newTabValue) => {
    setTabValue(newTabValue);
    history.push({ pathname: `/indique-e-ganhe/${newTabValue}` });
  };

  const handleSubmitIndicar = async (newData) => {
    // Separar DDD e Telefone
    const unmasked = TextHelper.unmask(newData.telefone);
    const ddd = unmasked.substr(0, 2);
    const tel = unmasked.substr(2, 9);

    // Pegar o objeto da linha de negocio
    const linha_de_negocio = linhasDeNegocio.find(({ id_linha_de_negocio }) => +id_linha_de_negocio === +newData.linha_de_negocio);

    const data = { ...newData, ddd, tel, linha_de_negocio };
    const { nome, email } = data;

    // Validação
    const errors = validateIndicar(data);
    formIndicarRef.current.setErrors(errors);

    if (Object.values(errors).length) {
      return modal.alert({
        title: 'Verifique os campos',
        content: ValidateHelper.listErrors(errors),
      });
    }

    setSavingIndicar(true);

    try {
      // O endpoint retorna o código do contrato do G1, e caso não exista, ele cria um
      const { data: afiliado } = await IndiqueGanheService.criarAfiliado(id_matricula);
      const codcontratoafiliacao = afiliado?.dados?.codcontratoafiliacao;

      if (!codcontratoafiliacao) {
        throw new Error('Não foi possível realizar a indicação.');
      }

      await IndiqueGanheService.salvarIndicado(
        codcontratoafiliacao,
        id_matricula,
        nome,
        tel,
        ddd,
        email,
        linha_de_negocio,
        AfiliadoIndicacaoOrigem.INDIQUE_GANHE_EGRESSO,
      );

      modal.alert({
        title: 'Sucesso!',
        content: `Sua indicação foi enviada.`,
      });

      // Resetar campos
      formIndicarRef.current.clearField('nome');
      formIndicarRef.current.clearField('email');
      formIndicarRef.current.clearField('telefone');

      setTabValue('meus-bonus');

      // Atualizar dados da tela ASYNC
      refreshDados().catch(() => null);
    } catch (err) {
      snackbar.error(UtilHelper.getReponseMessage(err));
    }

    setSavingIndicar(false);
  };

  const handleSubmitResgatar = async (newData) => {
    const data = {
      ...resgatar,
      ...newData,
    };

    // Validação
    const errors = validateResgatar(data);
    formResgatarRef.current.setErrors(errors);

    if (Object.values(errors).length) {
      return modal.alert({
        title: 'Verifique os campos',
        content: ValidateHelper.listErrors(errors),
      });
    }

    setSavingResgatar(true);

    const { id_situacao, nu_valor, id_afiliadoindicacaoparceiro } = data;

    try {
      await IndiqueGanheService.resgatarCupons(id_usuario, id_situacao, nu_valor, id_afiliadoindicacaoparceiro);

      modal.alert({
        title: 'Resgate realizado',
        content: `O bônus será liberado em até ${prazoValeDisponivel} dias.`,
      });

      setResgatar(resgatarDefaults);
      setTabValue('meus-bonus');

      await refreshDados();
    } catch (err) {
      snackbar.error(UtilHelper.getReponseMessage(err));
    }

    setSavingResgatar(false);
  };

  const handleChangeValorResgatar = (multiplier = 1) => {
    const { nu_disponivel = 0 } = dados || {};
    let { nu_valor } = resgatar;

    nu_valor += 100 * multiplier;

    // O valor deve ser múltiplo de 100
    if (nu_valor > 100 && nu_valor % 100 !== 0) {
      nu_valor = Math.floor(nu_valor / 100) * 100;
    }

    // Não pode ser maior que o saldo disponível
    nu_valor = Math.min(nu_disponivel, nu_valor);

    // Não pode ser menor que zero
    nu_valor = Math.max(0, nu_valor);

    setResgatar({ ...resgatar, nu_valor });
    // formResgatarRef.current.setFieldValue('nu_valor', nu_valor);
  };

  const LinkRegulamento = () => (
    <Link href="#" onClick={handleRegulamento}>
      regulamento
    </Link>
  );

  return (
    <TabContext value={tabValue}>
      <Box className={classes.header}>
        <Container>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={4} md={3} className="text-center">
              <img className={clsx('responsive', classes.imgBanner)} src={imgBanner} alt="Programa Indique e Ganhe" />
            </Grid>
            <Grid item xs sm={8} md={8}>
              <Grid container spacing={1}>
                <Grid item xs={12}>
                  <Title>
                    indique e ganhe
                    <Box component="span" color="text.primary">
                      {' '}
                      egresso
                    </Box>
                  </Title>
                </Grid>
                <Grid item component={Typography} xs={12}>
                  <b>Sua indicação vale muito, até R$ 500,00 por matrícula!</b>
                </Grid>
                <Grid item component={Typography} xs={12} align="justify">
                  A pessoa indicada ganha um desconto especial e você ganha um incrível vale-compras caso ela efetive a matrícula.
                </Grid>
                <Grid item component={Typography} xs={12} variant="caption">
                  <Box my={2}>
                    * Confira o <LinkRegulamento />.
                  </Box>
                </Grid>
                <Grid item xs={12}>
                  <Grid container spacing={2}>
                    {tabs.map(({ label, value }) => (
                      <Grid item xs={12} sm={4} lg={3} key={value}>
                        <MUIButton
                          className={classes.tabBtn}
                          fullWidth
                          variant={tabValue === value ? 'contained' : 'outlined'}
                          color="secondary"
                          onClick={() => handleChangeTab(value)}
                        >
                          {label}
                        </MUIButton>
                      </Grid>
                    ))}
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Container>
      </Box>
      <Container className={classes.content}>
        <Grid container>
          <Hidden xsDown>
            <Grid item xs md={3} />
          </Hidden>
          <Grid item xs={12} sm={8} lg={6}>
            <TabPanel className={classes.tabPanel} value="indicar-pessoas">
              <Subtitle mb={2}>indicar pessoas</Subtitle>
              <NotLoading loading={!dados}>
                <Box my={2}>
                  <Typography align="justify">
                    Indique apenas quem você imagina que queira receber um desconto especial para estudar na Unyleya! Assim você ajuda quem realmente precisa de
                    um incentivo!
                  </Typography>
                </Box>
                <Box my={2}>
                  <Typography>
                    <b>Quero indicar essa pessoa para estudar na Unyleya:</b>
                  </Typography>
                </Box>
                <Form ref={formIndicarRef} onSubmit={handleSubmitIndicar}>
                  <Grid container spacing={3}>
                    <Grid item xs={12} md={9}>
                      <Input label="Nome da pessoa indicada" name="nome" autoComplete="off" />
                    </Grid>
                    <Grid item xs={12} md={9}>
                      <Input label="Celular da pessoa indicada" name="telefone" autoComplete="off" mask="phone" />
                    </Grid>
                    <Grid item xs={12} md={9}>
                      <Input type="email" label="E-mail da pessoa indicada" name="email" autoComplete="off" />
                    </Grid>
                    <Grid item xs={12} md={9}>
                      <Typography>Qual o interesse da pessoa indicada?</Typography>
                      <Radio
                        name="linha_de_negocio"
                        options={[
                          { value: '2', label: 'Graduação', id: 'linha_de_negocio_gra' },
                          { value: '3', label: 'Pós-Graduação', id: 'linha_de_negocio_pos' },
                        ]}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <Divider className={classes.divider} />
                    </Grid>
                    <Grid item>
                      <Check
                        name="termos_aceitos"
                        label={
                          <>
                            Aceito os termos e concordo com o <LinkRegulamento />.
                          </>
                        }
                      />
                    </Grid>
                    <Grid item xs={12} className="text-right">
                      <Button type="submit" endIcon={<SendIcon />} loading={savingIndicar}>
                        enviar indicação
                      </Button>
                    </Grid>
                  </Grid>
                </Form>
              </NotLoading>
            </TabPanel>

            {/*---------------------*/}

            <TabPanel className={classes.tabPanel} value="como-funciona">
              <Subtitle mb={2}>como funciona?</Subtitle>
              <NotLoading loading={!funcionamento}>
                <Html html={funcionamento?.st_textosistemabody} />
              </NotLoading>
            </TabPanel>

            {/*---------------------*/}

            <TabPanel className={classes.tabPanel} value="meus-bonus">
              <Subtitle mb={2}>meus bônus $</Subtitle>

              <NotLoading loading={!dados} placeholder="Buscando indicações...">
                {!dados?.indicacoes?.length ? (
                  <Box my={2}>
                    <Box my={2}>
                      <Typography>
                        <b>Você ainda não indicou ninguém :(</b>
                      </Typography>
                    </Box>
                    <Box my={2}>
                      <Typography>
                        Acesse "indicar pessoas" e informe uma pessoa que teria interesse em estudar na Unyleya, na Graduação ou na Pós-Graduação, com um
                        desconto especial!
                      </Typography>
                    </Box>
                    <Box my={2}>
                      <Typography>Quando ela se matricula, você ganha um bônus!</Typography>
                    </Box>
                  </Box>
                ) : (
                  <IndicacaoList {...dados} refreshing={refreshing} setTabValue={setTabValue} bl_inadimplente={statusInadimplente?.bl_inadimplente} />
                )}
              </NotLoading>
            </TabPanel>

            {/*---------------------*/}

            <TabPanel className={classes.tabPanel} value="resgatar">
              <Subtitle mb={2}>resgatar</Subtitle>
              <NotLoading loading={!parceiros}>
                <Form ref={formResgatarRef} initialData={resgatar} onSubmit={handleSubmitResgatar}>
                  <Box color="secondary.light" bgcolor="action.hover" borderRadius={5} align="center" p={2} my={1}>
                    <b>SALDO DE BÔNUS: {TextHelper.toMoney(dados?.nu_disponivel)}</b>
                  </Box>
                  <Box my={2} align="center">
                    <Typography>Qual valor gostaria de resgatar?</Typography>
                  </Box>
                  <Box my={2}>
                    <Grid container justifyContent="center">
                      <Grid item>
                        <Input
                          readOnly
                          name="nu_valor"
                          value={resgatar.nu_valor}
                          style={{ width: 160 }}
                          InputProps={{
                            startAdornment: <InputAdornment position="start">R$</InputAdornment>,
                            endAdornment: (
                              <InputAdornment position="end">
                                <Box mr={-1}>
                                  <IconButton size="small" edge="end" color="secondary" onClick={() => handleChangeValorResgatar(1)}>
                                    <ArrowDropUpIcon />
                                  </IconButton>
                                  <br />
                                  <IconButton size="small" edge="end" color="secondary" onClick={() => handleChangeValorResgatar(-1)}>
                                    <ArrowDropDownIcon />
                                  </IconButton>
                                </Box>
                              </InputAdornment>
                            ),
                          }}
                        />
                      </Grid>
                    </Grid>
                  </Box>

                  <Box my={4}>
                    <Divider className={classes.divider} />
                  </Box>

                  <Box bgcolor="action.hover" borderRadius={5} align="center" my={1} p={2}>
                    <Box my={1}>
                      <b>Vale presente para compras online</b>
                    </Box>
                    <Box my={1}>
                      Você receberá as informações do vale presente por e-mail em até {prazoValeDisponivel} dias. Verifique também a sua caixa de spam.
                    </Box>
                    <Box my={1}>Esta operação não pode ser desfeita.</Box>
                    <Box mt={3} mb={1}>
                      <b>Escolha o parceiro:</b>
                    </Box>

                    <NotEmpty data={parceiros}>
                      <Radio
                        name="id_afiliadoindicacaoparceiro"
                        options={parceiros?.map((parceiro) => ({
                          className: classes.parceiroLabel,
                          value: parceiro.id_afiliadoindicacaoparceiro,
                          label: <img className="responsive" src={imgParceiros[parceiro.st_icone]} alt={parceiro.st_afiliadoindicacaoparceiro} />,
                          labelPlacement: 'top',
                        }))}
                      />
                    </NotEmpty>

                    <Box mt={2} align="center" color="primary.main">
                      <b>Valor: {TextHelper.toMoney(resgatar.nu_valor)}</b>
                    </Box>
                  </Box>

                  <Box align="center" my={3}>
                    <Button type="submit" loading={savingResgatar}>
                      confirmar resgate
                    </Button>
                  </Box>
                </Form>
              </NotLoading>
            </TabPanel>
          </Grid>
        </Grid>
      </Container>
    </TabContext>
  );
}

const Regulamento = ({ idMatricula }) => {
  const getRegulamento = useCallback(async () => IndiqueGanheService.getRegulamento(idMatricula), [idMatricula]);

  const { data: regulamento } = useOffline('IndiqueGanhe.Regulamento', getRegulamento);

  return (
    <NotLoading loading={!regulamento} placeholder="Buscando regulamento...">
      <Html html={regulamento?.st_textosistemabody} />
    </NotLoading>
  );
};
